import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Entries',
      value: stats?.totalEntries,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Symptoms Tracked',
      value: stats?.symptomsTracked,
      icon: 'Activity',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: 'Avg Severity',
      value: `${stats?.avgSeverity}/10`,
      icon: 'TrendingUp',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Days Tracked',
      value: stats?.daysTracked,
      icon: 'Calendar',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-xl border border-border shadow-therapeutic p-4 md:p-6 hover:shadow-therapeutic-md transition-smooth"
        >
          <div className={`inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg ${stat?.bgColor} mb-3 md:mb-4`}>
            <Icon name={stat?.icon} size={20} className={stat?.color} strokeWidth={2} />
          </div>
          <div className="text-2xl md:text-3xl font-bold text-foreground mb-1">
            {stat?.value}
          </div>
          <div className="text-xs md:text-sm text-muted-foreground">
            {stat?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;